var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRealtime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 77,
    viewBox: "0 0 90 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_198_23780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.8334 1.26416H8.3727C4.66384 1.26416 1.65723 4.27078 1.65723 7.97963V56.499C1.65723 60.2079 4.66384 63.2145 8.3727 63.2145H73.8334C77.5423 63.2145 80.5489 60.2079 80.5489 56.499V7.97963C80.5489 4.27078 77.5423 1.26416 73.8334 1.26416Z",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4092 63.2135H67.9974V70.6526H13.4092V63.2135Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4092 63.2135H67.9974V68.133C67.9974 68.8013 67.732 69.4421 67.2595 69.9147C66.7869 70.3872 66.1461 70.6526 65.4778 70.6526H15.9288C15.2606 70.6526 14.6197 70.3872 14.1472 69.9147C13.6747 69.4421 13.4092 68.8013 13.4092 68.133L13.4092 63.2135Z",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4582 9.12366H68.7507C69.9598 9.12366 71.1194 9.60396 71.9743 10.4589C72.8293 11.3139 73.3096 12.4734 73.3096 13.6825V51.1455C73.3096 52.3546 72.8293 53.5141 71.9743 54.3691C71.1194 55.224 69.9598 55.7043 68.7507 55.7043H13.4582C12.2492 55.7043 11.0896 55.224 10.2347 54.3691C9.37972 53.5141 8.89941 52.3546 8.89941 51.1455V13.6825C8.89941 12.4734 9.37972 11.3139 10.2347 10.4589C11.0896 9.60396 12.2492 9.12366 13.4582 9.12366Z",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1656 32.7874L26.3986 40.0298L17.5073 30.5146C17.0279 29.9353 16.6732 29.2633 16.4652 28.5407C16.2573 27.8181 16.2006 27.0603 16.2987 26.3148C16.3968 25.5693 16.6476 24.852 17.0354 24.2078C17.4232 23.5636 17.9397 23.0063 18.5527 22.5707C19.1656 22.1351 19.8618 21.8305 20.5977 21.6761C21.3336 21.5217 22.0935 21.5207 22.8298 21.6732C23.5661 21.8257 24.2631 22.1284 24.8771 22.5624C25.4912 22.9964 26.0091 23.5524 26.3986 24.1956C27.1024 23.0347 28.2128 22.1771 29.5138 21.7894C30.8148 21.4018 32.2135 21.5118 33.4379 22.0981C34.6623 22.6844 35.6249 23.705 36.1386 24.9616C36.6523 26.2182 36.6803 27.621 36.2172 28.8971",
    stroke: "#F69A4D",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4268 30.5327H42.2931L45.1336 35.2076L48.1519 30.5327H54.8989L58.465 23.3169L62.1195 30.5327H68.6296",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.167 38.3009H65.0204",
    stroke: "black",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.167 42.6373H60.2847",
    stroke: "black",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3091 75.8803C81.3261 75.8803 87.8252 69.3812 87.8252 61.3642C87.8252 53.3471 81.3261 46.848 73.3091 46.848C65.2921 46.848 58.793 53.3471 58.793 61.3642C58.793 69.3812 65.2921 75.8803 73.3091 75.8803Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.3096 52.9982V63.1592H79.5576",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3096 52.9982V63.1592H79.5576",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_198_23780"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 77,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealtime);
export default __webpack_public_path__ + "static/media/realtime.2e3c6563c8d097b6808187e10fe69a15.svg";
export { ForwardRef as ReactComponent };